<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>系统通知</span>
        <div class="filters">
          <el-select v-model="filterStatus" placeholder="状态" clearable style="width: 140px" @change="handleSearch">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
          <el-button type="primary" size="small" @click="openDialog()">新增通知</el-button>
        </div>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
        <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
              {{ labelOf(SYSTEM_NOTICE_STATUS, row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="publishedAt" label="推送时间" min-width="160" :formatter="formatTime" />
        <el-table-column prop="createdAt" label="创建时间" min-width="160" :formatter="formatTime" />
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDetail(row)">查看</el-button>
            <el-button v-if="row.status === 0" type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button
              v-if="row.status === 0"
              type="text"
              size="small"
              class="primary"
              @click="handlePublish(row)"
            >推送</el-button>
            <el-button type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>

    <el-dialog :title="form.id ? '编辑系统通知' : '新增系统通知'" :visible.sync="visible" width="560px" top="8vh">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" maxlength="200" show-word-limit placeholder="通知标题" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="8"
            maxlength="5000"
            show-word-limit
            placeholder="通知正文，推送后所有用户可在消息中心查看"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="通知详情" :visible.sync="detailVisible" width="560px" top="8vh">
      <div v-if="detailData" class="detail-box">
        <div class="detail-row">
          <span class="detail-label">状态</span>
          <el-tag :type="detailData.status === 1 ? 'success' : 'info'" size="small">
            {{ labelOf(SYSTEM_NOTICE_STATUS, detailData.status) }}
          </el-tag>
        </div>
        <div class="detail-row">
          <span class="detail-label">标题</span>
          <span>{{ detailData.title }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">内容</span>
          <p class="detail-content">{{ detailData.content }}</p>
        </div>
        <div v-if="detailData.publishedAt" class="detail-row">
          <span class="detail-label">推送时间</span>
          <span>{{ formatTime(null, null, detailData.publishedAt) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">创建时间</span>
          <span>{{ formatTime(null, null, detailData.createdAt) }}</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button
          v-if="detailData && detailData.status === 0"
          type="primary"
          :loading="publishing"
          @click="handlePublish(detailData)"
        >立即推送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSystemNotices,
  saveSystemNotice,
  deleteSystemNotice,
  publishSystemNotice
} from '@/api/admin'
import { SYSTEM_NOTICE_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import listPage from '@/mixins/listPage'

export default {
  name: 'SystemNotices',
  mixins: [listPage],
  data() {
    return {
      SYSTEM_NOTICE_STATUS,
      filterStatus: null,
      visible: false,
      detailVisible: false,
      detailData: null,
      submitting: false,
      publishing: false,
      form: { id: null, title: '', content: '' },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(SYSTEM_NOTICE_STATUS)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    formatTime(row, column, value) {
      if (!value) return ''
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return value
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    fetchList(params) {
      return getSystemNotices({
        ...params,
        status: this.filterStatus !== null && this.filterStatus !== '' ? this.filterStatus : undefined
      })
    },
    openDialog(row) {
      this.form = row
        ? { id: row.id, title: row.title, content: row.content }
        : { id: null, title: '', content: '' }
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    openDetail(row) {
      this.detailData = { ...row }
      this.detailVisible = true
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await saveSystemNotice({ ...this.form })
          this.$message.success('保存成功')
          this.visible = false
          this.loadList()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handlePublish(row) {
      this.$confirm('推送后所有用户将在消息中心收到该通知，是否继续？', '确认推送', {
        type: 'warning'
      }).then(async () => {
        this.publishing = true
        try {
          await publishSystemNotice(row.id)
          this.$message.success('推送成功')
          this.detailVisible = false
          this.loadList()
        } catch (e) {
        } finally {
          this.publishing = false
        }
      }).catch(() => {})
    },
    handleDelete(row) {
      this.$confirm('确定删除该通知？', '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteSystemNotice(row.id)
          this.$message.success('已删除')
          this.loadList()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filters {
  display: flex;
  align-items: center;
  gap: 8px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.danger {
  color: #f56c6c;
}
.primary {
  color: #409eff;
}
.detail-box {
  line-height: 1.6;
}
.detail-row {
  margin-bottom: 12px;
}
.detail-label {
  display: block;
  color: #909399;
  font-size: 12px;
  margin-bottom: 4px;
}
.detail-content {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
